import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import HeaderAndBanner from '../HeaderAndBanner/HeaderBanner';
import Modal from '../../Components/Modal/Modal';

// CC
import CCSignupForm from '../../Apps/CC/src/Components/SignUpForm/SignUpForm';
import CCSignInForm from '../../Apps/CC/src/Components/SignInForm/SignInForm';
import ResetPasswordCC from '../../Apps/CC/src/Components/ResetPassword/ResetPassword';

// HS
import HSSignInForm from '../../Apps/HS/src/Components/SignInForm/SignInForm';
import ResetPasswordHS from '../../Apps/HS/src/Components/ResetPassword/ResetPassword';

// TC
import TCSignupForm from '../../Apps/TC/src/Components/SignUpForm/SignUpForm';
import TCSignInForm from '../../Apps/TC/src/Components/SignInForm/SignInForm';
import ResetPasswordTC from '../../Apps/TC/src/Components/ResetPassword/ResetPassword';

import { remove, retrieve } from '../../Services/localStorageService';
import { clearAuth as clearCCAuth } from '../../Apps/CC/Config/Auth';
import { clearAuth as clearHSAuth } from '../../Apps/HS/Config/Auth';
import { clearAuth as clearTCAuth } from '../../Apps/TC/Config/Auth';


const Home = () => {

    const [showModal, setShowModal] = useState(null);    // showModal values: 'signinCC', 'signupCC', 'signinHS', 'resetHS', 'resetCC', 'signinTC', 'signupTC', 'resetTC'
    const [searchParams, setSearchParams] = useSearchParams();
    const token = searchParams.get('token');

    useEffect(() => {
        if (window.location.pathname === "/") {
            clearCCAuth();
            clearHSAuth();
            clearTCAuth();
        }
    }, []);

    useEffect(() => {
        const shouldShowCC = retrieve('showSignInModalCC');
        const shouldShowHS = retrieve("showSignInModalHS");
        const shouldShowTC = retrieve("showSignInModalTC");

        const openCCSignIn = searchParams.get('openCCSignIn');
        const openTCSignIn = searchParams.get('openTCSignIn');
        const token = searchParams.get('token');
        const appType = searchParams.get('appType');

        // CC SignIn
        if (shouldShowCC === 'true') {
            setShowModal('signinCC');
            remove('showSignInModalCC');
        }
        // HS SignIn
        else if (shouldShowHS === "true") {
            setShowModal("signinHS")
            remove("showSignInModalHS")
        }
        // TC SignIn
        else if (shouldShowTC === "true") {
            setShowModal("signinTC");
            remove("showSignInModalTC");
        }
        // HS Reset
        else if (token && appType === 'HS') {
            setShowModal('resetHS');
        }
        // TC Reset
        else if (token && appType === 'TC') {
            setShowModal('resetTC');
        }
        // CC Reset
        else if (token && appType === 'CC') {
            setShowModal('resetCC');
        }
        // Open CC SignIn via param
        else if (openCCSignIn === 'true') {
            setShowModal('signinCC');
        }
        // Open TC SignIn via param
        else if (openTCSignIn === 'true') {
            setShowModal('signinTC');
        }
    }, [searchParams]);

    const openSignup = (type = 'cc') => {
        if (type === 'cc') setShowModal('signupCC');
        else if (type === 'tc') setShowModal('signupTC');
    };

    const openSignin = (type = 'cc') => {
        if (type === 'cc') setShowModal('signinCC');
        else if (type === 'hs') setShowModal('signinHS');
        else if (type === 'tc') setShowModal('signinTC');
    };

    const handleClose = () => {
        setShowModal(null);
        searchParams.delete('token');
        searchParams.delete('openCCSignIn');
        searchParams.delete('openTCSignIn');
        setSearchParams(searchParams);
    };

    return (
        <>
            <HeaderAndBanner onSignUpClick={openSignup} onSignInClick={openSignin} />

            {showModal && (
                <Modal>
                    {showModal === 'signupCC' && (
                        <CCSignupForm onClose={handleClose} onOpenSignin={() => setShowModal('signinCC')} />
                    )}
                    {showModal === 'signinCC' && (
                        <CCSignInForm onClose={handleClose} onOpenSignup={() => setShowModal('signupCC')} />
                    )}
                    {showModal === 'resetCC' && (
                        <ResetPasswordCC onClose={handleClose} token={token} />
                    )}

                    {showModal === 'signinHS' && (
                        <HSSignInForm onClose={handleClose} />
                    )}
                    {showModal === 'resetHS' && (
                        <ResetPasswordHS onClose={handleClose} token={token} />
                    )}

                    {showModal === 'signupTC' && (
                        <TCSignupForm onClose={handleClose} onOpenSignin={() => setShowModal('signinTC')} />
                    )}
                    {showModal === 'signinTC' && (
                        <TCSignInForm onClose={handleClose} onOpenSignup={() => setShowModal('signupTC')} />
                    )}
                    {showModal === 'resetTC' && (
                        <ResetPasswordTC onClose={handleClose} token={token} />
                    )}
                </Modal>
            )}
        </>
    );
};

export default Home;
